import { Box, Button, IconButton } from "@mui/material";
import { useFieldArray, useFormContext } from "react-hook-form";
import { defineMessages } from "react-intl";
import { RHFTextField } from "../../../components/Forms/Fields";
import { notBlank } from "../../../components/Forms/validations";
import { Icon } from "../../../components/Icon";
import { useMsg } from "../../../components/Msg/Msg";
import { RefreshableChip } from "../../AIRecommendations/RefreshableChip";
import { useListHints } from "../../AIRecommendations/useListHints.hook";
// import { P } from "../../../components/Typography";

export const actionStepsMessages = defineMessages({
  "action-steps.label.placeholder": {
    id: "action-steps.label.placeholder",
    defaultMessage: "Label",
  },
  "action-steps.due-date.label": {
    id: "action-steps.due-date.label",
    defaultMessage: "Due date",
  },
  "action-steps.add-button": {
    id: "action-steps.add-button",
    defaultMessage: "Add action",
  },
  "action-steps.done": {
    id: "action-steps.done",
    defaultMessage: "Done",
  },
});

export const ActionSteps = ({
  name,
  rules,
  control,
  sx = {},
  hints = [],
  hintsLoading = false,
  onRemove,
}) => {
  const msg = useMsg({ dict: actionStepsMessages });
  const methods = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control: control || methods?.control,
    name,
    rules,
  });
  const { getHintAt, handleRefreshMaybe } = useListHints({
    hints,
    values: methods.watch(name).map((item) => item.label),
  });

  const getLabelName = (index) => `${name}.${index}.label`;
  // const getDateName = (index) => `${name}.${index}.date`;
  const onChipClick = ({ text, id: index }) => {
    methods.setValue(getLabelName(index), text, { shouldValidate: true });
  };

  // console.log("[ActionSteps.rndr]", { labelValues, hints, listHints, unusedHints });

  const canDeleteRow = (index) => index >= (rules?.minLength || 0);

  return (
    <Box sx={{ ...sx }}>
      {fields.map((field, index) => (
        <Box
          key={field.id}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            justifyContent: "flex-start",
            mb: 2,
          }}
        >
          <Box
            key={field.id}
            sx={{
              display: "flex",
              alignItems: "stretch",
              // mb: 2,
            }}
          >
            <Box sx={{ width: 16, mx: 1, mt: 1.5 }}>{index + 1}.</Box>
            <Box
              // component={"li"}
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                transition: "all 0.3s ease",
              }}
            >
              <RHFTextField
                fullWidth
                control={control}
                name={getLabelName(index)}
                placeholder={msg("action-steps.label.placeholder")}
                rules={{ required: true, validate: { notBlank: notBlank() } }}
                inputProps={{ maxLength: 150 }}
                withHelperTextSpace
                autoFocus
                sx={{
                  mb: 0.5,
                  flex: 1,
                  // "& .MuiFormHelperText-root.Mui-error": { height: 0, position: "relative", mt: 0, textAlign: "right", },
                }}
              />
              {/* <P sx={{ ml: 4, mr: 2 }}>{msg("action-steps.due-date.label")}</P>
               <DatePickerField
                control={control}
                name={getDateName(index)}
                rules={{ validate: { invalidDate, todayOrFuture } }}
                disablePast
                clearable
                sx={{ width: 180 }}
              /> */}
              {canDeleteRow(index) && (
                <IconButton
                  onClick={() => {
                    remove(index);
                    onRemove?.(index);
                  }}
                  sx={{
                    ml: 1,
                    mb: 3,
                    flexShrink: 0,
                  }}
                >
                  <Icon name="Delete" />
                </IconButton>
              )}
            </Box>
          </Box>
          <Box sx={{ ml: 4 }}>
            <RefreshableChip
              id={index}
              text={getHintAt(index)}
              onChipClick={onChipClick}
              onRefreshMaybe={handleRefreshMaybe}
              isLoading={hintsLoading}
            />
          </Box>
        </Box>
      ))}
      <Button
        onClick={() =>
          append({
            label: "",
            date: null,
          })
        }
        startIcon={<Icon name="Add" />}
      >
        {msg("action-steps.add-button")}
      </Button>
    </Box>
  );
};
